import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Import des guards
import { AuthGuard } from './guards/auth.guard';
import { AccueilComponent } from './components/accueil/accueil.component';
import { PublicComponent } from './components/public/public.component';
import { ErrorComponent } from './components/error/error.component';
import { MessagesComponent } from './components/pages/messages/messages.component';
import { OpenComponent } from './components/pages/open/open.component';
import { CreateComponent } from './components/pages/create/create.component';
import { OtpComponent } from './components/pages/otp/otp.component';
import { OpenMessageUrlComponent } from './components/pages/open-message-url/open-message-url.component';
import { DirectoryComponent } from './components/pages/directory/directory.component';
import { RevokeConsentComponent } from './components/pages/revoke-consent/revoke-consent.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SettingsUserComponent } from './components/settings-user/settings-user.component';
import { SettingsFoldersComponent } from './components/settings-folders/settings-folders.component';
import { DirectoryResolver } from './resolvers/directory.resolver';
import { SuperAdminComponent } from './components/pages/super-admin/super-admin.component';
import { PsAdminComponent } from './components/modules/superAdmin/ps-admin/ps-admin.component';
import { ClientAdminComponent } from './components/modules/superAdmin/client-admin/client-admin.component';
import { AccueilAdminComponent } from './components/modules/superAdmin/accueil-admin/accueil-admin.component';
import { ClientsResolver } from './resolvers/clients.resolver';
import { CguComponent } from './components/pages/cgu/cgu.component';

const routes: Routes = [
    { path: '', redirectTo: '/public', pathMatch: 'full' },
    { path: 'public', component: PublicComponent},
    { path: 'settings', component: SettingsComponent, canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_USER'], otp: true, cgu: true},
        children: [
            { path: '', redirectTo: 'user', pathMatch: 'full' },
            { path: 'user', component: SettingsUserComponent },
            { path: 'folders', component: SettingsFoldersComponent },
        ]
    },
    { path: 'homepage', component: AccueilComponent,  canActivate: [ AuthGuard ], data: { roles: [ 'ROLE_MML_PATIENT_USER' ]}},
    { path: 'folders/:folderId', component: MessagesComponent, canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_USER'], otp: true, cgu: true}},
    { path: 'open/:ref', component: OpenComponent, canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_USER'], otp: true, cgu: true}},
    { path: 'create', component: CreateComponent, canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_USER'], otp: true, cgu: true}},
    { path: 'directory', component: DirectoryComponent, resolve: {directory: DirectoryResolver},
    canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_USER'], otp: true, cgu: true}},
    { path: 'otp', component: OtpComponent, canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_USER'], otp: false, cgu: false}},
    { path: 'cgu', component: CguComponent, canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_USER'], otp: false, cgu: false}},
    { path: 'open/client/:ref', component: OtpComponent, data: { otp: false }},
    { path: 'open/client/message/:ref', component: OpenMessageUrlComponent, data: { otp: true }},
    { path: 'revokeConsent/:ref', component: RevokeConsentComponent, data: { otp: false}},
    { path: 'error', component: ErrorComponent, data: { otp: false }},
    { path: 'superAdmin', component: SuperAdminComponent, canActivate: [ AuthGuard ], data: { roles: ['ROLE_MML_PATIENT_ADMIN', 'ROLE_MIPIH'], otp: true, cgu: true},
        children : [
            { path: '', component: AccueilAdminComponent },
            { path: 'psAdmin', component: PsAdminComponent, resolve: {clients: ClientsResolver} },
            { path: 'clientAdmin', component: ClientAdminComponent, resolve: {clients: ClientsResolver} }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})

export class AppRoutingModule { }
